import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    Box,
    Button,
    IconButton,
    Step,
    StepLabel,
    Stepper,
    TextField,
    Typography,
    Menu,
    MenuItem,
    useMediaQuery,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Checkbox,
    FormGroup,
    Select,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ConstructionIcon from "@mui/icons-material/Construction";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import HelpIcon from "@mui/icons-material/Help";
import { RootState } from "../../redux/store";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { setActiveStep, setPolicyName } from "../../redux/features/Form/FormSlice";
const steps = ["Basic Info", "Accrual Setup", "Summary"];
const NewPolicy = () => {
    const dispatch = useDispatch();
    const { activeStep, policyName } = useSelector((state: RootState) => state.form);
    const isMobile = useMediaQuery("(max-width:600px)");
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    // const [days, setDays] = useState<string[]>([]);
    const [hours, setHours] = useState<number | string>("");
    const [frequency, setFrequency] = useState<string>("");
    const [accrualOptions, setAccrualOptions] = useState({
        waitingPeriod: false,
        accrualCap: false,
        carryOver: false,
    });

    const handleAccrualOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setAccrualOptions((prevOptions) => ({
            ...prevOptions,
            [name]: value === "true",
        }));
    };

    const navigate = useNavigate();

    const handleNext = () => {
        if (activeStep === steps.length - 1) {
            navigate("/new");
        } else {
            dispatch(setActiveStep(activeStep + 1));
        }
    };

    const handleHoursChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setHours(event.target.value);
    };

    const handleFrequencyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFrequency(event.target.value);
    };
    const [onThe, setOnThe] = useState<string>("");
    const [milestones, setMilestones] = useState<
        { id: number; title: string; description: string; days: number; hours: number }[]
    >([]);
    const onTheChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOnThe(event.target.value);
    };

    const [capSelected, setCapSelected] = useState<{ [key: number]: boolean }>({});
    const handleCapChange = (id: number, value: string) => {
        setCapSelected((prev) => ({ ...prev, [id]: value === "yes" }));
    };

    const [carryoverSelected, setCarryoverSelected] = useState<{ [key: number]: boolean }>({});
    const handleCarryoverChange = (id: number, value: string) => {
        setCarryoverSelected((prev) => ({ ...prev, [id]: value === "yes" }));
    };
    const handleChange = (id: number, field: string, value: string) => {
        setMilestones((prevMilestones) =>
            prevMilestones.map((milestone) => (milestone.id === id ? { ...milestone, [field]: value } : milestone))
        );
    };

    const addMilestone = () => {
        setMilestones((prevMilestones) => [
            ...prevMilestones,
            {
                id: prevMilestones.length + 1,
                title: `Milestone ${prevMilestones.length + 1}`,
                description: "",
                days: 0,
                hours: 0,
            },
        ]);
    };

    const removeMilestone = (id: number) => {
        setMilestones((prevMilestones) => prevMilestones.filter((milestone) => milestone.id !== id));
    };

    const handleBack = () => {
        dispatch(setActiveStep(activeStep - 1));
    };

    const handleDropdownClose = () => {
        setAnchorEl(null);
    };

    const handleCategorySelect = (category: string) => {
        console.log("Selected category:", category);
        setAnchorEl(null);
    };

    const renderStepContent = (step: number) => {
        switch (step) {
            case 0:
                return (
                    <Box
                        sx={{
                            position: "static",
                            bottom: 0,
                            backgroundColor: "#fff",
                            padding: 2,
                            boxShadow: "0px -2px 5px rgba(0,0,0,0.1)",
                        }}
                    >
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Let’s start with some of the basic info.
                        </Typography>
                        <TextField
                            label="Policy Name"
                            required
                            value={policyName}
                            onChange={(e) => dispatch(setPolicyName(e.target.value))}
                            placeholder="e.g. Salary Employees"
                            margin="normal"
                            error={!policyName}
                            helperText={!policyName ? "Policy Name is required" : ""}
                        />
                        {/* Card Section */}
                        <Box>
                            <Typography variant="h6">New Category</Typography>

                            <TextField
                                select
                                value={frequency}
                                onChange={handleFrequencyChange}
                                sx={{ flex: "1 1 500px" }}
                            >
                                <MenuItem value="Twice a month"> Bereavement</MenuItem>
                                <MenuItem value="Monthly">Sick</MenuItem>
                                <MenuItem value="Yearly"> Vacation</MenuItem>
                                <MenuItem value="Weekly"> Traditional</MenuItem>
                            </TextField>

                            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleDropdownClose}>
                                <MenuItem onClick={() => handleCategorySelect("Category 1")}>Bereavement</MenuItem>
                                <MenuItem onClick={() => handleCategorySelect("Category 2")}>Sick</MenuItem>
                                <MenuItem onClick={() => handleCategorySelect("Category 3")}>Vacation</MenuItem>
                                <MenuItem onClick={() => handleCategorySelect("Category 4")}>Traditional</MenuItem>
                            </Menu>
                        </Box>
                    </Box>
                );
            case 1:
                return (
                    <>
                        <Box
                            sx={{
                                position: "static",
                                bottom: 0,
                                backgroundColor: "#fff",
                                padding: 2,
                                boxShadow: "0px -2px 5px rgba(0,0,0,0.1)",
                            }}
                        >
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                <CalendarTodayIcon /> Accrual Schedule.
                            </Typography>

                            <Box
                                component="form"
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 2,
                                    width: "100%",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        flexWrap: "wrap",
                                    }}
                                >
                                    <Typography>Employee Accrue</Typography>
                                    <TextField
                                        type="number"
                                        value={hours}
                                        onChange={handleHoursChange}
                                        sx={{ width: "150px" }}
                                    />
                                    <Typography>Hour</Typography>
                                    <TextField
                                        select
                                        value={frequency}
                                        onChange={handleFrequencyChange}
                                        sx={{ width: "200px" }}
                                    >
                                        <MenuItem value="Twice a month">Twice a month</MenuItem>
                                        <MenuItem value="Monthly">Monthly</MenuItem>
                                        <MenuItem value="Weekly">Weekly</MenuItem>
                                    </TextField>
                                    <FormControl
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            gap: 1,
                                        }}
                                    >
                                        <Typography>On the</Typography>
                                        <TextField select value={onThe} onChange={onTheChange} sx={{ width: "100px" }}>
                                            <MenuItem value="1st">1st</MenuItem>
                                            <MenuItem value="2nd">2nd</MenuItem>
                                            <MenuItem value="3rd">3rd</MenuItem>
                                            <MenuItem value="4th">4th</MenuItem>
                                            <MenuItem value="5th">5th</MenuItem>
                                            <MenuItem value="6th">6th</MenuItem>
                                            <MenuItem value="7th">7th</MenuItem>
                                            <MenuItem value="8th">8th</MenuItem>
                                        </TextField>
                                        <Typography>and</Typography>
                                        <TextField select value={onThe} onChange={onTheChange} sx={{ width: "100px" }}>
                                            <MenuItem value="1st">1st</MenuItem>
                                            <MenuItem value="2nd">2nd</MenuItem>
                                            <MenuItem value="3rd">3rd</MenuItem>
                                            <MenuItem value="4th">4th</MenuItem>
                                            <MenuItem value="5th">5th</MenuItem>
                                            <MenuItem value="6th">6th</MenuItem>
                                            <MenuItem value="7th">7th</MenuItem>
                                            <MenuItem value="8th">8th</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Box>
                            </Box>
                            <br></br>
                            <hr></hr>
                            <FormControl component="fieldset">
                                <Typography>Accrual Options</Typography>

                                <RadioGroup
                                    name="waitingPeriod"
                                    value={accrualOptions.waitingPeriod ? "true" : "false"}
                                    onChange={(e) =>
                                        handleAccrualOptionChange({
                                            ...e,
                                            target: { ...e.target, name: "waitingPeriod" },
                                        })
                                    }
                                >
                                    <FormControlLabel
                                        value="false"
                                        control={<Radio />}
                                        label="No, they begin accruing time immediately on hire"
                                    />
                                    <FormControlLabel
                                        value="true"
                                        control={<Radio />}
                                        label="Yes, there is a waiting period"
                                    />
                                </RadioGroup>

                                <RadioGroup
                                    name="accrualCap"
                                    value={accrualOptions.accrualCap ? "true" : "false"}
                                    onChange={(e) =>
                                        handleAccrualOptionChange({
                                            ...e,
                                            target: { ...e.target, name: "accrualCap" },
                                        })
                                    }
                                >
                                    <FormControlLabel
                                        value="false"
                                        control={<Radio />}
                                        label="No, they will continue to accrue time, regardless of balance"
                                    />
                                    <FormControlLabel
                                        value="true"
                                        control={<Radio />}
                                        label="Yes, they stop accruing at a certain balance"
                                    />
                                </RadioGroup>

                                <RadioGroup
                                    name="carryOver"
                                    value={accrualOptions.carryOver ? "true" : "false"}
                                    onChange={(e) =>
                                        handleAccrualOptionChange({
                                            ...e,
                                            target: { ...e.target, name: "carryOver" },
                                        })
                                    }
                                >
                                    <FormControlLabel
                                        value="false"
                                        control={<Radio />}
                                        label="No, it’s 'use it or lose it'"
                                    />
                                    <FormControlLabel
                                        value="true"
                                        control={<Radio />}
                                        label="Yes, unused time off can be carried over"
                                    />
                                </RadioGroup>
                            </FormControl>

                            <Box display="flex" gap={4} p={3}>
                                <Stepper activeStep={milestones.length - 1} orientation="vertical">
                                    {milestones.map((milestone) => (
                                        <Step key={milestone.id}>
                                            <StepLabel>Milestone {milestone.id}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>

                                <Box flex={1}>
                                    {milestones.map((milestone) => (
                                        <Box key={milestone.id}>
                                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                                <Typography variant="h6">Employees reach this Milestone...</Typography>
                                                <IconButton color="error" onClick={() => removeMilestone(milestone.id)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Box>

                                            <Box display="flex" gap={2} mt={1}>
                                                <TextField
                                                    type="text"
                                                    variant="outlined"
                                                    value={milestone.days}
                                                    onChange={(e) => handleChange(milestone.id, "days", e.target.value)}
                                                />
                                                <Select value="Days">
                                                    <MenuItem value="Days">Days</MenuItem>
                                                    <MenuItem value="Weeks">Weeks</MenuItem>
                                                    <MenuItem value="Months">Months</MenuItem>
                                                    <MenuItem value="Years">Years</MenuItem>
                                                </Select>
                                                after hire date
                                            </Box>
                                            <br />
                                            <hr />

                                            <Typography mt={3}>Accrual Options</Typography>
                                            <Box display="flex" gap={2} mt={1}>
                                                Employees accrue
                                                <TextField
                                                    variant="outlined"
                                                    value={milestone.hours}
                                                    onChange={(e) =>
                                                        handleChange(milestone.id, "hours", e.target.value)
                                                    }
                                                />
                                                <Typography variant="body1">hours monthly on the 1st.</Typography>
                                            </Box>

                                            {/* Cap on Accrual Balance */}
                                            <Typography variant="h6" mt={3}>
                                                Is there a cap on the balance an employee can accrue?
                                            </Typography>
                                            <RadioGroup
                                                value={capSelected[milestone.id] ? "yes" : "no"}
                                                onChange={(e) => handleCapChange(milestone.id, e.target.value)}
                                            >
                                                <FormControlLabel
                                                    value="no"
                                                    control={<Radio />}
                                                    label="No, they will continue to accrue time, regardless of balance"
                                                />
                                                <FormControlLabel
                                                    value="yes"
                                                    control={<Radio />}
                                                    label="Yes, they stop accruing at a certain balance"
                                                />
                                            </RadioGroup>

                                            {/* Additional Fields when 'Yes' is Selected */}
                                            {capSelected[milestone.id] && (
                                                <Box mt={2}>
                                                    <Typography>
                                                        Stop accruing time when an employee hits a balance of... *
                                                    </Typography>
                                                    <TextField
                                                        type="text"
                                                        variant="outlined"
                                                        onChange={(e) =>
                                                            handleChange(milestone.id, "maxBalance", e.target.value)
                                                        }
                                                    />
                                                    hours
                                                </Box>
                                            )}

                                            {/* Carry Over Policy */}
                                            <Typography variant="h6" mt={3}>
                                                Can unused time off be carried over after the carryover date?
                                            </Typography>
                                            <RadioGroup
                                                value={carryoverSelected[milestone.id] ? "yes" : "no"}
                                                onChange={(e) => handleCarryoverChange(milestone.id, e.target.value)}
                                            >
                                                <FormControlLabel
                                                    value="no"
                                                    control={<Radio />}
                                                    label="No, it's 'use it or lose it'"
                                                />
                                                <FormControlLabel
                                                    value="yes"
                                                    control={<Radio />}
                                                    label="Yes, time can be carried over"
                                                />
                                            </RadioGroup>

                                            {/* Additional Fields when 'Yes' is Selected */}
                                            {carryoverSelected[milestone.id] && (
                                                <Box mt={2}>
                                                    <Typography>How much time can be carried over?:</Typography>
                                                    <Select value="Up to...">
                                                        <MenuItem value="Up to...">Up to...</MenuItem>
                                                        <MenuItem value="Unlimited">Unlimited</MenuItem>
                                                    </Select>
                                                    <TextField
                                                        type="text"
                                                        variant="outlined"
                                                        onChange={(e) =>
                                                            handleChange(milestone.id, "maxCarryover", e.target.value)
                                                        }
                                                    />
                                                    hours
                                                </Box>
                                            )}

                                            <hr />
                                        </Box>
                                    ))}

                                    {/* Add Milestone Button - Left Aligned */}
                                    <Box textAlign="left" mt={2}>
                                        <Button color="primary" onClick={addMilestone}>
                                            + Add Milestone
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <br></br>

                        <Box
                            sx={{
                                position: "static",
                                bottom: 0,
                                backgroundColor: "#fff",
                                padding: 2,
                                boxShadow: "0px -2px 5px rgba(0,0,0,0.1)",
                            }}
                        >
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                <AutorenewIcon />
                                Carryover Rules
                            </Typography>

                            <Typography>What should the carryover date be?</Typography>
                            <TextField
                                select
                                value={frequency}
                                onChange={handleFrequencyChange}
                                sx={{ flex: "1 1 500px" }}
                            >
                                <MenuItem value="Twice a month">1st of January</MenuItem>
                                <MenuItem value="Monthly">Employee hire date</MenuItem>
                                <MenuItem value="Weekly">Others...</MenuItem>
                            </TextField>

                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox />}
                                    label={
                                        <>
                                            Reset negative balances to 0 hours on carryover date
                                            <IconButton>
                                                <HelpIcon />
                                            </IconButton>
                                        </>
                                    }
                                />
                            </FormGroup>
                        </Box>
                        <br></br>

                        <Box
                            sx={{
                                position: "static",
                                bottom: 0,
                                backgroundColor: "#fff",
                                padding: 2,
                            }}
                        >
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                <ConstructionIcon /> Some Fine-tuning
                            </Typography>

                            <Typography>Employees’ first accrual should be...</Typography>
                            <TextField
                                select
                                value={frequency}
                                onChange={handleFrequencyChange}
                                sx={{ flex: "1 1 500px" }}
                            >
                                <MenuItem value="Twice a month">Prorated,based on the accruel period</MenuItem>
                                <MenuItem value="Monthly">The full amount of the accruel period</MenuItem>
                            </TextField>
                            <IconButton>
                                <HelpIcon />
                            </IconButton>

                            <Typography>Employees receive accrued time...</Typography>
                            <TextField
                                select
                                value={frequency}
                                onChange={handleFrequencyChange}
                                sx={{ flex: "1 1 500px" }}
                            >
                                <MenuItem value="Twice a month">At the end of accruel period</MenuItem>
                                <MenuItem value="Monthly">At the start of accruel period</MenuItem>
                            </TextField>
                            <IconButton>
                                <HelpIcon />
                            </IconButton>
                        </Box>
                    </>
                );
            case 2:
                return (
                    <Box
                        sx={{
                            position: "static",
                            bottom: 0,
                            backgroundColor: "#fff",
                            padding: 2,
                            boxShadow: "0px -2px 5px rgba(0,0,0,0.1)",
                        }}
                    >
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            All set? Let’s make sure everything looks right
                        </Typography>
                        <Typography>We love surprises, but not when it comes to time off.</Typography>
                        <br></br>
                        <hr></hr>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            <CalendarTodayIcon />
                            Starting on hire date
                        </Typography>
                        <Typography>
                            Employees accrue 2 hours twice a month on the 1st and 15th. They will lose all time not used
                            by January 1st.
                        </Typography>
                    </Box>
                );
            default:
                return null;
        }
    };

    return (
        <Box
            sx={{
                width: "100%",
                padding: isMobile ? 2 : 4,
                overflowY: "auto",
                height: "100vh",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <IconButton onClick={() => console.log("Back arrow clicked")}>
                    <ArrowBackIcon />
                    <Typography sx={{ fontSize: isMobile ? 16 : 20, textAlign: "start" }}>Time Off</Typography>
                </IconButton>
            </Box>

            <Typography
                variant="h3"
                sx={{
                    color: "#2196f3",
                    fontFamily: "Roboto",
                    textAlign: "start",
                    fontWeight: "bold",
                    fontSize: isMobile ? 24 : 32,
                }}
            >
                New Policy
            </Typography>

            <Stepper
                activeStep={activeStep}
                orientation={isMobile ? "vertical" : "horizontal"}
                sx={{
                    mt: 3,
                    position: "static",
                    bottom: 0,
                    backgroundColor: "#fff",
                    padding: 2,
                    display: "flex",
                    marginBottom: 5,
                    justifyContent: "space-between",
                    boxShadow: "0px -2px 5px rgba(0,0,0,0.1)",
                }}
            >
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <Box sx={{ mt: 4, minHeight: "40vh" }}>{renderStepContent(activeStep)}</Box>

            {/* Navigation Buttons */}
            <Box
                sx={{
                    backgroundColor: "#fff",
                    padding: 2,
                    display: "flex",
                    marginTop: 5,
                    marginBottom: 5,
                    justifyContent: "space-between",
                    boxShadow: "0px -2px 5px rgba(0,0,0,0.1)",
                }}
            >
                <Button disabled={activeStep === 0} onClick={handleBack} variant="outlined">
                    Back
                </Button>

                <Button
                    variant="contained"
                    onClick={handleNext}
                    color="success"
                    disabled={activeStep === 0 && !policyName}
                >
                    {activeStep === steps.length - 1 ? "Finish" : "Next Step"}
                </Button>
            </Box>
        </Box>
    );
};

export default NewPolicy;
